import Vue from 'vue';

import ThirdParty from './third-party'; // 引用本工程的插件（第三方组件库等）
import ThemePart from './theme';
import AppPart from './app/index';

import './public-path';
import './polyfills';
import { MessageBox } from 'element-ui';
import $api from './apiAxios';

import { Mentions, Modal, Descriptions } from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';

Vue.prototype.$bus = new Vue();
Vue.prototype.$confirmWarning = (message, title = '提示', cfg = {}) => {
    cfg = Object.assign({
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        type: 'warning'
    }, cfg);
    return MessageBox.confirm(message, title, cfg);
};
Vue.prototype.$api = $api;

Vue.use(Mentions);
Vue.use(Modal);
Vue.use(Descriptions);

Vue.config.productionTip = false;
Vue.use(ThirdParty);
Vue.use(ThemePart);
Vue.use(AppPart);

// 入口页面初始化
(async () => {
    let { default: App } = await import('./app/App');
    let { default: router } = await import('./app/router');
    let { default: store } = await import('./store');

    // 手动设置全局的$store
    Vue.prototype.$store = store;
    // 根据用户信息接口确认是否登录过期或未登录
    store.dispatch('account/getUserInfo').then((res) => {
        store.dispatch('account/getGlobalConfigs').finally(() => {
            // 创建Vue根实例（实例创建后，开始进行层层渲染）
            new Vue({
                router,
                store,
                render: h => h(App)
            }).$mount('#app');
        });
    });
})();
